<template lang="pug">
dialog-base(
  v-bind="attrs"
  v-on="$listeners"
)
  portal(:to="`${constants.DIALOG_PORTAL_KEY}.content`")
    p.text-body-1 Перейдите в бота и из списка команд выберите "Авторизоваться"
  portal(:to="`${constants.DIALOG_PORTAL_KEY}.actions`")
    app-button(
      rounded
      block
      @click="toTelegram"
    ) Перейти в бота
</template>

<script>
import DialogBase from './DialogBase.vue';
import { TELEGRAM_BOT_URL } from '@/modules/UserProfile/components/Profile/Sections/constants';

const DIALOG_PORTAL_KEY = 'telegram-link-dialog';

export default {
  name: 'LinkDialog',
  components: {
    DialogBase,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    attrs() {
      return {
        ...this.$attrs,
        portalKey: DIALOG_PORTAL_KEY,
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    toTelegram() {
      const { dev, prod } = TELEGRAM_BOT_URL;
      const botUrl = this.isProduction ? prod : dev;

      window.open(botUrl, '_blank');
    },
  },
};
</script>
